export var ModalContainerAudioRecord = {
    container: null,
    init: function (idDiv) {
        ModalContainerAudioRecord.container = document.querySelector('#'+idDiv);
        if (!ModalContainerAudioRecord.container) {
            ModalContainerAudioRecord.container = document.createElement('div');
            ModalContainerAudioRecord.container.id = idDiv;
            ModalContainerAudioRecord.container.hidden = true;
            document.body.appendChild(ModalContainerAudioRecord.container);

            m.mount(ModalContainerAudioRecord.container, m.component(ModalViewAudioRecord, {title: ""}));
        }
    },
    open: function () {
        if(ModalContainerAudioRecord.container === null)
            ModalContainerAudioRecord.container = document.querySelector('#'+idDiv);
        if (ModalContainerAudioRecord.container ) {
            //document.getElementById("srcIframe").srcdoc = srcdoc;
            ModalContainerAudioRecord.container.hidden = false;
            m.redraw.strategy("diff");
        }
    },
    close: function (save = false ) {
        let event;
        if(save)
            event = new Event("stopAudioRecord", {bubbles: true});
        else
            event = new Event("breakAudioRecord", {bubbles: true});
        document.dispatchEvent(event);
        ModalContainerAudioRecord.container.hidden = true;
        let timerId = localStorage.getItem("audioTimerId");
        clearInterval(timerId);
        localStorage.removeItem("audioTimerId");
        document.getElementById("audioTimer").innerHTML = "00:00";
    }
};

var ModalViewAudioRecord = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay[id='']", [
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal[style='border: 0; width: 100%; max-width: 54em; ']", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[style='padding-right: 20px;'][id='headerModalAccCard']", "Звукозапись"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: function () { ModalContainerAudioRecord.close(false) }
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Отменить')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px; width: 100%; height: auto; display: block; position: relative;']", [
                                    m("div[id='audioTimer'][style='border: 0;text-align: center; color: red; font-size: 30px;font-weight: 500;width: 100%;']", {

                                    }, ["00:00"]),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m("button.btn", {
                                            onclick: function () {
                                                localStorage.setItem("lengthAudio", document.getElementById("audioTimer").innerHTML);
                                                let event = new Event("stopAudioRecord", {bubbles: true});
                                                document.dispatchEvent(event);
                                                ModalContainerAudioRecord.container.hidden = true;
                                                let timerId = localStorage.getItem("audioTimerId");
                                                clearInterval(timerId);
                                                localStorage.removeItem("audioTimerId");
                                                document.getElementById("audioTimer").innerHTML = "00:00";
                                            }
                                        }, [
                                            m("div.record-button.bg-record-start[id='mic_bg'][style='width:50px; height:50px']", [
                                                m("i.fa.fa-2x.fa-thin.fa-microphone[id='mic_icon'][style='color: white']")
                                            ])
                                        ]),
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        ])];
    }
};
